<template>
  <div>
    <div v-if="jobObj" class="container job-details">
      <div class="row top-synopsis">
        <div v-if="title" class="col-sm-12 col-md-7 col-lg-7 col-xl-7 details">
          <div class="">
            <div class="content-text">{{ jobObj.company_name }}</div>
            <div class="title-job">{{ title }}</div>
          </div>
        </div>
        <div
          class="col-sm-12 col-md-5 col-lg-5 col-xl-5 no-padding bottomButton"
        >
          <div class="box-left">
            <span @click="openConfirmationBox('edit')" class="btn btn-save">
              <span class="dlt">Edit</span>
            </span>
            <span
              v-if="compliance"
              @click="openConfirmationBox('approve')"
              class="btn btn-save-new"
              style="margin-left: 1rem"
            >
              <span class="edt">Approve</span>
            </span>
            <span
              style="margin-left: 1rem"
              @click="openConfirmationBox('decline')"
              class="btn btn-close"
            >
              <span class="dlt">Decline</span>
            </span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 details">
          <div v-if="no_of_vacancy" class="box-row">
            <div class="title-text">Number of Vacancy</div>
            <div class="content-text">{{ no_of_vacancy }}</div>
          </div>
          <div v-if="position" class="box-row">
            <div class="title-text">Job Nature</div>
            <div class="content-text">{{ position }}</div>
          </div>
          <div v-if="expLevel" class="box-row">
            <div class="title-text">Seniority Level</div>
            <div class="content-text">{{ expLevel }}</div>
          </div>
          <div v-if="details" class="box-row">
            <div class="title-text">Description</div>
            <div v-html="details" class="content-text"></div>
          </div>
          <div v-if="jobresp" class="box-row">
            <div class="title-text">Job Responsibilities</div>
            <div v-html="jobresp" class="content-text"></div>
          </div>
          <div v-if="degrees.length > 0" class="box-row">
            <div class="title-text">Degrees</div>
            <div class="content-text">
              <span
                :key="index"
                style="padding-right: .5rem"
                v-for="(degree, index) in degrees"
              >
                {{ degree.degree_name }}
                <span v-if="degree.major_name">
                  in {{ degree.major_name }}</span
                >
                <span v-if="index < degrees.length - 1">,</span>
                <span v-else>.</span>
              </span>
            </div>
          </div>
          <div v-if="skills" class="box-row">
            <div class="title-text">Skills</div>
            <div class="content-text">{{ skills }}</div>
          </div>
          <div v-if="niceToHave" class="box-row">
            <div class="title-text">Nice to have</div>
            <div v-html="niceToHave" class="content-text"></div>
          </div>
          <div v-if="req_id" class="box-row">
            <div class="title-text">Req ID</div>
            <div class="content-text">{{ req_id }}</div>
          </div>
          <div v-if="location" class="box-row">
            <div class="title-text">Location</div>
            <div class="content-text">{{ location }}</div>
          </div>
          <div v-if="benefits" class="box-row">
            <div class="title-text">Benefits</div>
            <div v-html="benefits" class="content-text"></div>
          </div>
          <div v-if="salary" class="box-row">
            <div class="title-text">Salary</div>
            <div class="content-text">{{ salary }}</div>
          </div>
        </div>
      </div>
    </div>
    <div :key="change" v-if="showConfirmation">
      <confirmation-box
        v-bind="confirmation"
        v-on:on-click-ok="confirmAction"
        v-on:on-click-cancel="showConfirmation = false"
      ></confirmation-box>
    </div>
  </div>
</template>

<script>
import * as SYSTEM_FUNCTIONS from "../../../globalFunctions";
import * as FILTERS from "../../../filters";
import ConfirmationBox from "../../global-components/confirmation-pop-up";
import { GET_JOB_DETAILS } from "../../../Api/common_api";

export default {
  name: "job-details",
  components: {
    // EditJob,
    ConfirmationBox
  },
  props: {
    job: Object,
    compliance: Boolean,
    index: Number
  },
  data: function() {
    return {
      phone: SYSTEM_FUNCTIONS.PHONE(),
      req_id: null,
      jobresp: null,
      benefits: null,
      no_of_vacancy: null,
      title: null,
      details: null,
      position: null,
      expLevel: null,
      skills: null,
      niceToHave: null,
      salary: null,
      degrees: [],
      location: null,
      jobObj: null,
      showConfirmation: false,
      confirmation: {
        open: false,
        title: "String",
        message: "String"
      },
      change: 0,
      action: null,
      currentIndex: this.index
    };
  },
  methods: {
    openConfirmationBox(action) {
      const self = this;
      self.showConfirmation = true;
      self.action = action;
      switch (action) {
        case "approve":
          self.confirmation = {
            open: true,
            title: "Confirmation !",
            message: self.$constants.JOB_CLOSING_MESSAGES.APPROVE_JOB
          };
          break;
        case "decline":
          self.confirmation = {
            open: true,
            title: "Be Careful !",
            message: self.$constants.JOB_CLOSING_MESSAGES.DISCARD_JOB
          };
          break;
        case "edit":
          self.confirmation = {
            open: true,
            title: "Confirmation !",
            message: self.$constants.JOB_CLOSING_MESSAGES.EDIT_JOB
          };
          break;
      }
      self.change++;
    },
    confirmAction() {
      const self = this;
      switch (self.action) {
        case "approve":
          self.$emit("change-status", self.jobObj.job_id, 5, self.currentIndex);
          break;
        case "decline":
          self.$emit("change-status", self.jobObj.job_id, 2, self.currentIndex);
          break;
        case "edit":
          self.$emit("edit-job", self.jobObj);
          break;
      }
      self.showConfirmation = false;
    }
  },
  mounted() {
    const self = this;
    if (self.job) {
      GET_JOB_DETAILS(self.job.job_id)
        .then(function(data) {
          self.jobObj = data;
          self.title = FILTERS.FIRST_LETTER_CAPITAL(self.jobObj.job_title);
          self.details = self.jobObj.rich_job_description;
          self.location = self.jobObj.location_name
            ? self.jobObj.location_name
            : null;
          self.position = SYSTEM_FUNCTIONS.GET_STRING_FROM_ARRAY(
            self.jobObj.position_type,
            ", "
          );
          self.expLevel = SYSTEM_FUNCTIONS.GET_STRING_FROM_ARRAY(
            self.jobObj.seniority_level,
            ", ",
            true
          );
          if (self.jobObj.degrees) {
            self.degrees = self.jobObj.degrees;
          }
          self.skills = SYSTEM_FUNCTIONS.GET_STRING_FROM_LIST_OF_SKILLS(
            self.jobObj.skills,
            ","
          );
          self.niceToHave = self.jobObj.rich_nice_to_have;
          if (self.jobObj.req_id) self.req_id = self.jobObj.req_id;
          if (self.jobObj.min_salary && self.jobObj.max_salary) {
            self.salary = SYSTEM_FUNCTIONS.SALARY_TEXT(
              self.jobObj.min_salary,
              self.jobObj.max_salary,
              self.jobObj.negotiable,
              self.jobObj.salary_basis
            );
          } else {
            if (self.jobObj.negotiable) {
              self.salary = "Negotiable";
            }
          }
          if (self.jobObj.job_responsibilities) {
            self.jobresp = self.jobObj.rich_job_responsibilities;
          }
          if (self.jobObj.job_benefits) {
            self.benefits = self.jobObj.rich_job_benefits;
          }
          if (self.jobObj.no_of_vacancy) {
            self.no_of_vacancy = self.jobObj.no_of_vacancy;
          }
        })
        .catch(function() {
          self.jobObj = self.job;
        });
    }
  }
};
</script>

<style scoped>
.job-details {
  padding: 1.5rem;
  background-color: #ffffff;
  height: 90vh;
  overflow-y: auto;
}
.top-synopsis {
  border-bottom: 0.1rem solid #eeeeee;
}
.details {
  padding: 0;
  width: 100%;
}
.box-row {
  padding: 1rem 0;
}
.box-left {
  padding: 1rem 0;
  text-align: right;
  margin-right: 1rem;
}
.title-job {
  font-size: 2rem;
  font-weight: bold;
  text-align: left;
  color: #050405;
  margin-bottom: 1rem;
  overflow-x: hidden;
}
.title-text {
  font-size: 1.6rem;
  line-height: 1.25;
  text-align: left;
  color: #050405;
}
.content-text {
  text-align: left;
  font-size: 1.4rem;
  color: #808080;
  font-weight: 100;
}
.dlt-ico {
  color: var(--button-delete-color);
}
.edt-ico {
  color: white;
}
/* .ico-style {
      padding: .2rem;
      margin: 0 .5rem;
      cursor: pointer;
    } */
/* .ico-style:hover .edt-ico {
      color: #11998e !important;
    } */
/* .ico-style:hover .dlt-ico {
      color: #ff5252 !important;
    } */
.dlt {
  /* padding-left: .5rem; */
}
.edt {
  padding-left: 0.5rem;
}
/* .ico-style:hover .dlt {
      color: #ff5252 !important;
    }
    .ico-style:hover .edt {
      color: #11998e !important;
    }*/

@media (max-width: 600px) {
  .job-details {
    margin: 0rem;
    padding: 0rem 1rem;
    height: auto;
  }
  .bottomButton {
    position: fixed;
    bottom: 0rem;
    left: 0rem;
    width: 100%;
    overflow: hidden;
  }
}
</style>
